var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"main"},[_c('div',{staticClass:"container"},[_c('el-card',{staticClass:"main-card"},[_c('router-view')],1)],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }